import {
    generateDefaultState,
    getActionTypes,
} from '../../../utils/reduxHelper';

export const actions = getActionTypes('storeSysId', [
    'GET_ALL',
    'UPDATE',
    'CREATE',
    'DELETE',
    'SET_FILTERS'
]);

export const initialStoreSysIdState = {
    ...generateDefaultState('storeSysId', [
        'GET_ALL',
        'UPDATE',
        'CREATE',
        'DELETE',
        'SET_FILTERS'
    ]),
};
